<template>
  <component
    :is="`svg-${name}`"
    v-if="name"
    :height="height"
    :width="width"
    :use-custom-dimensions="useCustomDimensions"
  />
</template>

<script>
import SvgJudicial from './icons/judicial.vue';
import SvgExecution from './icons/execution.vue';
import SvgDocumentation from './icons/documentation.vue';
import SvgRealEstateDeals from './icons/realEstateDeals.vue';

export default {
  name: 'AppSvg',
  components: {
    SvgJudicial,
    SvgExecution,
    SvgDocumentation,
    SvgRealEstateDeals,
  },
  props: {
    name: {
      required: true,
      type: String,
      default: '',
    },
    width: {
      required: false,
      type: [String, Number],
      default: 45,
    },
    height: {
      required: false,
      type: [String, Number],
      default: 45,
    },
    useCustomDimensions: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
};
</script>
